module.exports = __webpack_public_path__ + "static/img/about-step4p.5968d37e.png";